/**
 * URLパターンにマッチするか確かめる関数.
 * SPページ出しわけロジックの実装にあたって /search だけでなく /search/:id もサポート対象に含める必要が出てきたので、パス付きURLでも判定できるようにこの関数を用意した。
 * @param allowList 検索の対象のURL
 * @param targetPath 検索の文字列やパターン
 * @example isIncludePath(['search', 'hoge'], 'search') => true
 * @example isIncludePath(['search', 'hoge'], 'search/1234') => true
 */
export function isIncludePath(allowList: string[], targetPath: string) {
  if (targetPath === '/') {
    return true;
  }
  const newAllowList = allowList.filter((allow) => allow !== '/');
  for (let cnt = 0; cnt < newAllowList.length; cnt++) {
    const element = newAllowList[cnt];
    const elementRegExp = new RegExp('^' + element + '/?$' + '|' + element + '/[a-zA-Z0-9]+/?');
    const isInclude = elementRegExp.test(targetPath);
    if (isInclude) {
      return true;
    }
  }
  return false;
}
